import { registerPlugin, type PluginListenerHandle } from '@capacitor/core';

export interface NativeVoiceEvent {
  text?: string;
  code?: string;
  message?: string;
}

interface NativeVoicePlugin {
  isSttAvailable(): Promise<{ available: boolean; onDevice: boolean }>;
  startStt(options: { language?: string }): Promise<void>;
  stopStt(): Promise<void>;
  cancelStt(): Promise<void>;
  addListener(
    eventName:
      | 'sttReady'
      | 'sttSpeechStart'
      | 'sttSpeechEnd'
      | 'sttPartial'
      | 'sttFinal'
      | 'sttError'
      | 'sttEnd',
    listener: (data: NativeVoiceEvent) => void,
  ): Promise<PluginListenerHandle>;
}

export const nativeVoice = registerPlugin<NativeVoicePlugin>('NativeVoice');
